import { IoMdHelp } from "react-icons/io";
import { BsCaretRightFill } from "react-icons/bs";
import useApp from "../context/AppContext";
import { apiBlob } from "../utils/api";
import Popup from "reactjs-popup";
import { useEffect, useState } from "react";

const HelpIcon = () => {
  const { setLoading, usuario, showModalError } = useApp();
  const [show, setShow] = useState(false);
  const handleAjuda = () => {
    setLoading(true);
    apiBlob(usuario)
      .get("/documentos/visualizarManual", {})
      .then((resp) => {
        //VISUALIZAR ARQUIVO
        const file = new Blob([resp.data], { type: "application/pdf" });
        let fileURL = URL.createObjectURL(file);
        window.open(fileURL, "_blank");
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        showModalError("Erro ao baixar manual");
      });
  };
  useEffect(()=> {
    const path = window.location.href.substring(window.location.href.lastIndexOf("/") + 1);
    if (path === "" || path === "fornecedores" ||  path === "login")
      setShow(true)

  },[window.location.href])
  const path = window.location.href.substring(window.location.href.lastIndexOf("/") + 1);
  return (
    <div className="float no-print">
      {(show) && (
        <div onClick={()=>setShow(false)}>
          <div className="float d-flex" style={{ right: "80px", bottom: "20px" }}>
            <div className="card p-3 border border-dark shadow">
              <div className="d-flex flex-row text-primary"><h5>Manual </h5><span className="ms-1">(atualizado em 12/07/2022)</span></div>
              <span>Em caso de dúvidas clique no botão ao lado<br/> e faça o download do manual de operação.</span>
            </div>
            <BsCaretRightFill size={20} color="rgb(5, 5, 173)" style={{ marginTop: "58px" }} />
          </div>
        </div>
      )}
      <div className="rounded-circle border border-2 border-primary shadow">
        <button
          className="rounded-button-icon"
          onClick={handleAjuda}
          onMouseOver={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
        >
          <IoMdHelp size={20} />
        </button>
      </div>
    </div>
  );
};
export default HelpIcon;
